module.exports = __webpack_public_path__ + "static/img/office-london.0714ae2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/office-london.png
// module id = El0E
// module chunks = 1